import * as angular from 'angular';
import * as _ from 'lodash';
import * as moment from 'moment';
import { States } from "../../shared/config/constant.module";
import template from './measure.tpl.html';
import { StateParams } from "../../common";
import LoaderServiceName, { LoaderService } from "../../components/loader/loader.service";
import ReportServiceName, { ReportService } from "../../services/reports/report.service";
import MeasureServiceName, { MeasureService } from '../../services/dashboard/measure.service';
import AuthDataServiceName, { AuthDataService } from "../../services/auth/authData.service";
import NavigationServiceName, { NavigationService } from "../../services/navigation/navigation.service";
import { Plant } from '../../models/navigation';
import { apsViewModels } from '../../shared/dto/APS.ViewModels';
import NotifyServiceName, { NotifyService } from "../../services/notify/notify.service";
import EquipmentServiceName, { EquipmentService } from '../../services/equipment/equipment.service';
import { apsEnums } from '../../shared/dto/aps.enums';

let requires = [LoaderServiceName, MeasureServiceName, ReportServiceName, AuthDataServiceName, NavigationServiceName, EquipmentServiceName];

interface MeasureController {
  plants: Plant[];
  selectedPlant: Plant;
  selectedShop: apsViewModels.ShopNavigation;
  availableShops: apsViewModels.ShopNavigation[];
  selectedShops: apsViewModels.ShopNavigation[];

  addShop(): void;
  removeShop(shop: apsViewModels.ShopNavigation): void;
  form: angular.IFormController;
  updatePlant(): void;
  radioChange(any): void;
  occurenceType: string;
  isMinilab: boolean;
  isWSG: boolean;
  isWFG: boolean
}

export interface MeasureParams extends StateParams {
  reportPlantId: string;
  reportShopId: string;
  startDate: Date;
  endDate: Date;
}

class MeasureCtrl implements MeasureController {
  plants: Plant[];
  selectedPlant: Plant;
  availableItems: string[];
  selectedItem: string;
  startDate: Date;
  reportStartDate: Date;
  reportEndDate: Date;
  futureDate: Date;
  endDate: Date;
  selectedShop: apsViewModels.ShopNavigation;
  noRecords: boolean;
  availableShops: apsViewModels.ShopNavigation[];
  selectedShops: apsViewModels.ShopNavigation[];
  form: angular.IFormController;
  showLines: boolean;
  shiftName: string;
  $state: angular.ui.IStateService;
  loaderService: LoaderService;
  reportService: ReportService;
  measureService: MeasureService;
  authDataService: AuthDataService;
  notifyService: NotifyService;
  equipmentService: EquipmentService;
  $q: angular.IQService;
  occurenceType: string;
  isMinilab: boolean;
  isWFG: boolean;
  isWSG: boolean;
  reportLoadingPromise: angular.IDeferred<any>;
  reportAvailableThisWorkaround: any;
  isWXGEquipemntConfigured: boolean;

  private $stateParams: MeasureParams;

  constructor(
    $state: angular.ui.IStateService,
    $stateParams: MeasureParams,
    navigationService: NavigationService,
    reportService: ReportService,
    measureService: MeasureService,
    loaderService: LoaderService,
    authDataService: AuthDataService,
    notifyService: NotifyService,
    equipmentService: EquipmentService,
    $q: angular.IQService) {

    var vm = this;
    this.occurenceType = 'Minilab'
    this.isMinilab = true;
    this.$state = $state;
    this.$stateParams = $stateParams;
    this.loaderService = loaderService;
    this.reportService = reportService;
    this.measureService = measureService;
    this.equipmentService = equipmentService;
    this.authDataService = authDataService;
    this.notifyService = notifyService;
    this.$q = $q;
    this.isWXGEquipemntConfigured = false;

    var now = moment().add(1, 'hours').startOf('hour');
    this.reportEndDate = now.toDate();
    this.noRecords = false;
    this.reportStartDate = now.clone().subtract(1, 'days').toDate();
    this.futureDate = now.clone().add(1, 'days').toDate();
    var promise = navigationService.getNavigation().then((navModel) => {
      this.plants = navModel.plants().filter(x => !x.isDisabled);
      this.selectedPlant = navModel.selectedPlant;
      this.selectedShops = [];
      this.updatePlant();
      return this.loadState($stateParams).then(function () {
        vm.availableShops = _.clone(vm.selectedPlant.shops);
      });
    });
    loaderService.loadingPromise(promise);
  }

  loadState(params: MeasureParams): angular.IPromise<any> {
    if (params.reportPlantId && params.reportShopId && params.reportShopId !== params.shopId) {
      var plant = _.find(this.plants, { id: params.reportPlantId });
      if (plant) {
        var shop = _.find(plant.shops, { id: params.reportShopId });
        if (shop) {
          this.selectedPlant = plant;
        }
      }
    }

    if (params.startDate) {
      var startDate = moment(params.startDate);
      if (startDate.isValid()) {
        this.startDate = startDate.toDate();
      }
    }

    return this.$q.when();
  }

  updateItems = () => {
    this.measureService.getPlantItems(this.selectedPlant.id)
      .then(Items => {
        this.availableItems = Items
      });
  }
  radioChange(type): void {
    if (type === 'Minilab') {
      this.isMinilab = true;
      this.isWFG = false;
      this.isWSG = false;
    }
    else if (type === 'Wsg') {
      this.isWSG = true;
      this.isMinilab = false;
      this.isWFG = false;
    }
    else {
      this.isMinilab = false;
      this.isWFG = true;
      this.isWSG = false;
    }
  }
  updatePlant = () => {
    this.noRecords = false;

    this.equipmentService.get(this.selectedPlant.id).then((data: apsViewModels.EquipmentDetail[]) => {
      this.isWXGEquipemntConfigured = data.filter(x => x.isDeleted === false && (x.type == apsEnums.EquipmentType.WFG || x.type == apsEnums.EquipmentType.WSG)).length > 0;
      if (!this.isWXGEquipemntConfigured) {
        this.occurenceType = 'Minilab';
        this.isMinilab = true;
      }
      else {
        this.occurenceType = 'Minilab';
        this.isMinilab = true;
      }
    });
    this.availableShops = this.selectedPlant.shops;
    if (this.selectedShops.length > 0) {
      this.selectedShops = [];
    }
    this.updateItems();
  }

  addShop = () => {
    this.noRecords = false;
    if (this.selectedShop === null || this.selectedShop === undefined) {
      this.selectedShops = [];
      this.selectedPlant.shops.forEach(element => {
        this.selectedShops.push(element);
      });
      this.availableShops = [];
    }
    else {
      var existing = this.selectedShops.filter(x => x.id == this.selectedShop.id);
      if (existing.length === 0) {
        this.selectedShops.push(this.selectedShop);
        _.remove(this.availableShops, this.selectedShop);
      }
    }
  }

  removeShop = (shop: apsViewModels.ShopNavigation) => {
    _.remove(this.selectedShops, shop);
    this.availableShops.push(shop);
  };


  saveState(): void {
    var reportPlantId = this.selectedPlant ? this.selectedPlant.id : undefined;
    if (reportPlantId === this.$stateParams.plantId) {
      reportPlantId = undefined;
    }
    var reportShopId = this.selectedShop ? this.selectedShop.id : undefined;
    if (reportShopId === this.$stateParams.shopId) {
      reportShopId = undefined;
    }

    var params: MeasureParams = {
      plantId: this.$stateParams.plantId,
      shopId: this.$stateParams.shopId,
      userId: this.$stateParams.userId,
      reportPlantId: reportPlantId,
      reportShopId: reportShopId,
      startDate: this.startDate ? this.startDate : undefined,
      endDate: this.endDate ? this.endDate : undefined
    };

    this.$state.transitionTo(this.$state.current.name, params);
  }

  generateCSV(regenerate: boolean) {
    if (this.form.$invalid) {
      return;
    }

    var diff = moment(this.endDate).diff(this.startDate, 'days')

    if (diff > 91) {
      this.notifyService.error('Date range cannot exceed 3 months');
      return;
    }
    if (this.startDate >= this.futureDate) {
      this.notifyService.error("Please select a valid Start Date");
      return;
    }
    if (this.endDate < this.startDate) {
      this.notifyService.error('End Date should be greater than Start Date');
      return;
    }
    if (!this.selectedItem && this.isMinilab) {
      this.notifyService.error('Please Enter a value for Item');
      return
    }

    this.saveState();
    this.loaderService.loadingPromise(this.runCSV());


  }

  private runCSV(): angular.IPromise<any> {
    var items = [];
    this.selectedShops.forEach(element => {
      items.push(element.id);
    });
    let csvPromise;
    if (this.isMinilab) {
      csvPromise = this.measureService.exportToCSV(this.selectedPlant.id, this.startDate, this.endDate, items, this.selectedItem);
    }
    else {
      if (this.isWFG) {
        csvPromise = this.measureService.wxgexportToCSV(this.selectedPlant.id, this.startDate, this.endDate, 1);
      }
      else {
        csvPromise = this.measureService.wxgexportToCSV(this.selectedPlant.id, this.startDate, this.endDate, 0);
      }
    }
    csvPromise.then((result: any) => {
      this.noRecords = false;
      if (result.indexOf("No Records") != -1) {
        this.noRecords = true;
        return;
      }
      var start = moment(this.startDate).format("dddd, MM/DD/YYYY");
      var end = moment(this.endDate).format("dddd, MM/DD/YYYY");
      var a = document.createElement("a");
      a.href = 'data:attachment/csv;charset=utf-8,' + result;
      a.target = '_blank';

      if (this.isMinilab) {
        a.download = this.selectedPlant.name + '-MiniLab' + '-Item_' + this.selectedItem + '-' + start + '-' + end + '.csv';
      }
      else {
        if (this.isWFG) {
          a.download = this.selectedPlant.name + '-WFG' + '-' + start + '-' + end + '.csv';
        }
        else {
          a.download = this.selectedPlant.name + '-WSG' + '-' + start + '-' + end + '.csv';
        }
      }
      document.body.appendChild(a);
      a.click();
    });
    return csvPromise;
  }
}

export default angular.module('aps.controller.measure', requires)
  .config(function ($stateProvider: angular.ui.IStateProvider) {
    $stateProvider.state({
      name: States.MEASURE,
      url: '/measure',
      controller: 'MeasureCtrl as vm',
      template: template,
      data: {
        pageTitle: 'Measure Data Import', v2Uri: 'aps/dashboard/plant/measurement'
      }
    });
  })
  .controller('MeasureCtrl', MeasureCtrl)
  .name;



// WEBPACK FOOTER //
// ./src/app/controllers/dashboard/measure.controller.ts